<script setup lang="ts">
import LGShopHero from "~/components/shop/LGShopHero.vue";
import LGShopGuides from "~/components/shop/LGShopGuides.vue";
import LGShopHowTo from "~/components/shop/LGShopHowTo.vue";
import LGShopReviews from "~/components/shop/LGShopReviews.vue";

const { t } = useI18n()

const title = t('shop.seo.title')
const description = t('shop.seo.description')

useSeoMeta({
    title,
    description,
    robots: 'index,follow',
})
</script>

<template>
    <div>
        <LGShopHero/>
        <LGShopGuides/>
        <LGShopHowTo/>
        <LGShopReviews/>
    </div>
</template>

<style scoped>

</style>
